// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__3VGPc","footer":"ChangeClinic_footer__2zqSa"};